import { useAppSelector } from 'app/store/hooks';

const useCurrentTheme = () => {
  const { currentTheme } = useAppSelector((s) => s.layout);
  return currentTheme;
};

export default useCurrentTheme;
